const AIVoiceProcessing = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">AI & Voice Data Processing</h2>
      <p className="mb-6">
        VTranslate uses third-party AI and voice processing services to provide translation, transcription, and text analysis features. Below is a summary of how your data is handled by each service.
      </p>

      <h3 className="text-xl font-semibold mb-3">Voice & Audio Data</h3>
      <p className="mb-6">
        When you use voice translation features, audio from your microphone is streamed in real-time to Soniox for speech-to-text transcription and translation. Audio is processed in real-time during active voice sessions only and is not permanently stored. Soniox uses this data solely for the purpose of providing transcription and translation services.
      </p>

      <h3 className="text-xl font-semibold mb-3">Text Content</h3>
      <p className="mb-6">
        When you use AI-assisted features (such as translation style suggestions, text refinement, and dictionary lookups), the text you enter is sent to OpenAI's API for processing. OpenAI does not use data submitted via their API for training models, as described in their{" "}
        <a href="https://openai.com/policies/privacy-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">data usage policy</a>.
      </p>

      <h3 className="text-xl font-semibold mb-3">Image & Camera Data</h3>
      <p className="mb-6">
        When you use the camera or image translation feature, images are sent to Google Cloud Vision API for optical character recognition (OCR) to extract text for translation. Images are processed and discarded; they are not permanently stored.
      </p>

      <h3 className="text-xl font-semibold mb-3">Related Privacy Policies</h3>
      <ul className="list-disc pl-6 mb-8">
        <li className="mb-2">
          <a href="https://openai.com/policies/privacy-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">OpenAI Privacy Policy</a>
        </li>
        <li className="mb-2">
          <a href="https://soniox.com/privacy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Soniox Privacy Policy</a>
        </li>
        <li className="mb-2">
          <a href="https://cloud.google.com/terms/cloud-privacy-notice" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Google Cloud Privacy Notice</a>
        </li>
        <li className="mb-2">
          <a href="https://privacy.microsoft.com/en-us/privacystatement" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Microsoft Privacy Statement</a>
        </li>
      </ul>
    </div>
  );
};

export default AIVoiceProcessing;
